import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class McDataService {
  private Datas :any

  constructor() { }

  public setIdsToken(id_token: string) {
    sessionStorage.setItem('idsToken',id_token);
  }

  public setDataLogin(Datas: any) {
    this.Datas = Datas;
  }

  public getIdsToken() {
    return sessionStorage.getItem('idsToken');
  }

  public getDataLogin() {
    return this.Datas
  }
}
